module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow-em-white-b826d5db85e5a3cfff6eeaf9a60b053e.svg";